
<template>
  <form @submit.prevent="handleSubmit" id="user_edit_form">
    <!-- Email Address -->
    <div class="mb-4 mt-2">
      <label class="form-label form-label-thin">Email Address <span class="text-danger">*</span></label>
      <input type="email" class="form-control form-control-thin" id="email" name="email" ref="email"
        v-model="form.email" placeholder="Email Address" />
    </div>

    <!-- First Name -->
    <div class="mb-4">
      <label class="form-label form-label-thin">First Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="first_name" name="first_name" ref="first_name"
        v-model="form.first_name" placeholder="First Name" />
    </div>

    <!-- Last Name -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Last Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="last_name" name="last_name" ref="last_name"
        v-model="form.last_name" placeholder="Last Name" />
    </div>

    <!-- Phone -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Phone</label>
      <input type="text" class="form-control form-control-thin" id="phone" name="phone" ref="phone"
        v-model="form.phone" placeholder="Phone Number" />
    </div>

    <div class="mb-4">
    <MultiSelect
        v-model="form.role"
        :options="roles"
        option-label="name"
        option-value="id"
        :multiple="false"
        label="User Role"
        placeholder="Select Role"
      />
    </div>

    <!-- Address -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Address</label>
      <textarea class="form-control form-control-thin" id="address" name="address" ref="address"
        v-model="form.address" placeholder="Full Address" rows="2"></textarea>
    </div>

    <!-- Modal Footer -->
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary hover-white" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn">
        <i class="fa-solid fa-check fs-12"></i> Update
      </button>
    </div>
  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import MultiSelect from '@/components/MultiSelect.vue'

export default {
  name: 'EditUser',
  emits: ['updated', 'close'],
  components: {
    MultiSelect
  },
  props: {
    roles: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
 data() {
  return {
    form: {
      id: '',
      first_name: '',
      last_name: '',
      email: '',
      role: '',
      phone: '',
      address: ''
    },
    roles: [],
    loading: false,
    submitting: false
  }
},
  watch: {
    user: {
      immediate: true,
      handler(val) {
        this.populateForm(val)
      }
    }
  },
  async mounted() {
  await this.fetchRoles()
},
  methods: {
   populateForm(user) {
  if (!user) return
  
  const roleId = user.get_current_company_role?.id ?? null
  
  console.log('user:', user)
  this.form = {
    id:         user.id         || '',
    first_name: user.first_name || '',
    last_name:  user.last_name  || '',
    email:      user.email      || '',
    role:       roleId,
    phone:      user.phone      || '',
    address:    user.address    || '',
  }
  
  console.log('Form role value:', this.form.role)
},
    async handleSubmit() {
      this.submitting = true

      try {
        const payload = {
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          email: this.form.email,
          role: this.form.role || null,
          phone: this.form.phone || null,
          address: this.form.address || null,
        }

        const result = await form_api_submit({
          url: `user/update/${this.form.id}`,
          method: 'POST',
          data: payload,
          curr_form_id: '#user_edit_form',
        })
         if (result.success) {
      this.$emit('created')
      this.close()
    }

      } finally {
        this.submitting = false
      }
    },
async fetchRoles() {
  this.loading = true

  try {
    const result = await form_api_submit({
      url: 'roles/get-roles',
      method: 'GET',
      show_success_toast: false,
      show_error_toast: true
    })

    if (result.success) {
      this.roles = result.data || []
    }
  } finally {
    this.loading = false
  }
},
    close() {
      this.$emit('close')
    }
  }
}
</script>